exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5 {\n  all: unset;\n  display: flex;\n  align-items: baseline;\n  font-size: .75rem;\n  font-weight: 400;\n  line-height: 1.25rem;\n  color: #373939;\n  margin-top: .5rem;\n  margin-left: auto;\n  cursor: pointer;\n}\n\n.care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5:focus {\n  outline: none;\n}\n\n.care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5 svg {\n  margin-left: .25rem;\n}\n\n.care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5.care-team-tasks--2CwWDlmS-cag2rM5TQtSSF svg {\n  transform: rotateX(180deg);\n}\n", ""]);

// exports
exports.locals = {
	"notesCollapseButton": "care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5",
	"notesCollapseButton": "care-team-tasks--3MiNhiC_lWdZhY1JEFRsc5",
	"isOpened": "care-team-tasks--2CwWDlmS-cag2rM5TQtSSF",
	"isOpened": "care-team-tasks--2CwWDlmS-cag2rM5TQtSSF"
};